import type { BlockSpeechBubble as BlockSpeechBubbleType } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'
import { BigQuotationMarks } from './BigQuotationMarks'
import { DarkSpeechBubble } from './DarkSpeechBubble'
import { DefaultSpeechBubble } from './DefaultSpeechBubble'

// Keys must match contentful variant
const VariantMapping: Record<
  string,
  FunctionComponent<React.PropsWithChildren<{ block: BlockSpeechBubbleType }>>
> = {
  DarkSpeechBubble: DarkSpeechBubble,
  BigQuotationMarks: BigQuotationMarks,
  Default: DefaultSpeechBubble,
}

export const BlockSpeechBubble: FunctionComponent<React.PropsWithChildren<{
  block: BlockSpeechBubbleType
}>> = ({ block }) => {
  if (!block.variant) return <DefaultSpeechBubble block={block} />
  const Component = VariantMapping[block.variant]
  return <Component block={block} />
}
